export const highlightText = (text: string, query: string): string => {
  if (!query) return text;

  const regex = new RegExp(`(${query})`, 'gi');
  return text.replace(regex, '<span style="background-color: yellow">$1</span>');
};

export const searchAndHighlight = (query: string) => {
  const elements = document.querySelectorAll('body *'); // Select all elements in the body

  console.log('Total Elements:', elements.length); // Debugging

  elements.forEach((element) => {
    if (element.textContent?.toLowerCase().includes(query.toLowerCase())) {
      console.log('Match Found:', element.textContent); // Debugging
      const highlightedText = highlightText(element.textContent, query);
      element.innerHTML = highlightedText;
    }
  });
};
